/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    
    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(params.leanF_p_d / 2 + 0.01), 0);
        model.lineTo(-(params.leanF_p_d / 2 + 0.01), sideWallCloseSize);
        model.lineTo(-(params.leanF_p_d / 2 - 0.16), sideWallCloseSize);
        model.lineTo(-(params.leanF_p_d / 2 - 0.16), 0);
        model.closePath();

        return model;
    }, [params.add_storage_check_front, sideWallCloseSize, params.p_b_c_b_f_b, params.add_left_front_lean_porch, params.leanF_p_h, params.leanF_p_d, params.p_b_c_b_f_l])

    const storageBackWall = useMemo(() => {

        let wainscot, trim;

        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModelTwo, extrudeSettings(0.22)));

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, -0.05);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.rotation.y = Math.PI / 2
        meshBackDelModel_Temp.position.set((params.leanF_p_d / -2 - 0.5), 0, -(params.p_d / 2 + params.leanF_p_w + 0.01));
        meshBackDelModel_Temp.updateMatrixWorld()

        let meshTrimModel_Temp = meshTrimModel.clone();
        // meshTrimModel_Temp.position.set(-parseInt(params.add_storage) - 0.1 - offset, 0, -0.02)
        meshTrimModel_Temp.updateMatrixWorld();
        
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);

        /**********************cutting hole using CSG Back Wainscot-trim************************/
        const meshWainscotTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_w )), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimBackModel_Temp = meshWainscotTrimBackModel.clone();
        meshWainscotTrimBackModel_Temp.rotation.y = Math.PI
        meshWainscotTrimBackModel_Temp.position.set((params.leanF_p_d / -2), 3, 0.15);
        meshWainscotTrimBackModel_Temp.updateMatrixWorld()

        const meshWainscotTrimBackModel_CSG = CSG.fromMesh(meshWainscotTrimBackModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

        const wainscotTrimSideModel_CSG = meshWainscotTrimBackModel_CSG.subtract(meshSideDelModel_CSG);
        const wainscotTrimBackModel_CSG = wainscotTrimSideModel_CSG.subtract(meshBackDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimBackModel = CSG.toMesh(wainscotTrimBackModel_CSG, new THREE.Matrix4())
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());
        wainscot = CSGWainscotTrimBackModel.geometry;
        trim = meshTrimDelModel.geometry;

        return {wainscot, trim};
    }, [params.p_d, params.leanF_p_w, params.leanF_p_d, params.frontLeanStoragePosition, const_var.newDoorsArray, params.leanF_p_pos, backWallVrTrimModelTwo])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_l === 'Open' || typeof(params.p_b_c_b_f_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h + 0.05;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_l === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_f_l, params.leanF_p_h, params.p_r_s])

    return (
        <group position={[0, 0, params.p_d / 2 + params.leanF_p_w + 0.01]}>
            <mesh name="storage-wall-trim" geometry={storageBackWall.trim} position={[-0.08, 0, 0]}>
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
            {params.p_w_c_n === true &&
                <mesh name="wainscotTrim" geometry={storageBackWall.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"frontLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel